import { mapState } from 'vuex'

var Categories = {
  created: function () {
    this.fetchAllCategories()
  },
  methods: {
    fetchAllCategories (params = '') {
      this.$store.dispatch('product/FetchAllCategories', params)
    }
  },
  computed: {
    ...mapState('product', ['categories'])
  }
}

export default Categories
